import React from 'react';
import { OfferRequisition } from '../../../../../../entities/v1/applicant_tracking/OfferRequisition';
import { CardEntry } from '../../../../../../components/ApplicantTracking/Requisition/CardEntry';
import RequisitionCard from '../../../../../../components/ApplicantTracking/Requisition/RequisitionCard';
import { humanizeCamelCase } from '../../../../../../utils/humanize';
import { SIGNABLE_OFFER_VARIABLES } from '../../../../../../containers/applicant_tracking/SignableOffers/variables';
import { camelCase } from 'lodash';
import { HorizontalDivider } from '../../../../../../components/HorizontallDivider';

interface PropTypes {
  offerRequisition: OfferRequisition;
}

const HORIZONTAL_LINE_BREAK = 4;

const OFFER_VARIABLES_PRIORITY_LIST = [
  'salary',
  'equity',
  'startingDate',
  'workingHours',
];

function getSortedKeys(
  offerVariables: Record<string, string | number>,
): string[] {
  return [
    ...OFFER_VARIABLES_PRIORITY_LIST.filter((key) => key in offerVariables),
    ...Object.keys(offerVariables)
      .filter((key) => !OFFER_VARIABLES_PRIORITY_LIST.includes(key))
      .sort(),
  ];
}

function getVariableWithSuffix(key: string, value: string | number): string {
  const variable = SIGNABLE_OFFER_VARIABLES.find(
    (v) => camelCase(v.name) === key,
  );
  return variable?.suffix ? `${value}${variable.suffix}` : `${value}`;
}

function getVariableLabel(key: string): string {
  const variable = SIGNABLE_OFFER_VARIABLES.find(
    (v) => camelCase(v.name) === key,
  );
  return variable?.label || humanizeCamelCase(key);
}

export default function OfferDetailsCard({ offerRequisition }: PropTypes) {
  const { variables: offerVariables } = offerRequisition.signableOffer;
  const sortedKeys = getSortedKeys(offerVariables);

  return (
    <RequisitionCard title='Offer Details'>
      {sortedKeys.map((key, index) => (
        <React.Fragment key={key}>
          <CardEntry
            label={getVariableLabel(key)}
            value={getVariableWithSuffix(key, offerVariables[key])}
          />
          {(index + 1) % HORIZONTAL_LINE_BREAK === 0 &&
            index + 1 < sortedKeys.length && <HorizontalDivider />}
        </React.Fragment>
      ))}
    </RequisitionCard>
  );
}
